export default "__VITE_ASSET__WpR0KWiR__"